const zh = {
  "nav.home": "首页",
  "nav.categories": "分类",
  "nav.articles": "文章",
  "nav.about": "关于我们",
  "nav.join": "加入开元",
  "nav.login": "登录",
  "nav.register": "注册",

  "hero.title": "专业运动平台",
  "hero.subtitle": "开启您的运动新旅程",
  "hero.description": "开元体育汇聚全球体育赛事资讯、专业运动健身指导与精彩体育娱乐内容，为您打造一站式运动生态体验平台。",
  "hero.cta": "立即加入",
  "hero.learnmore": "了解更多",

  "categories.title": "热门运动分类",
  "categories.subtitle": "多品类运动项目，满足您的各类运动需求",
  "categories.viewall": "查看全部",

  "featured.title": "精选文章",
  "featured.subtitle": "最新赛事资讯与运动健身指导",
  "featured.readmore": "阅读全文",
  "featured.views": "阅读量",
  "featured.date": "发布日期",

  "stats.title": "平台数据",
  "stats.members": "注册会员",
  "stats.articles": "优质文章",
  "stats.categories": "运动分类",
  "stats.coaches": "认证教练",

  "cta.title": "加入开元体育，开启运动新篇章",
  "cta.subtitle": "与千万运动爱好者一起，享受专业体育内容与互动社区",
  "cta.button": "免费注册",

  "about.title": "关于开元体育",
  "about.brand": "品牌介绍",
  "about.reputation": "口碑荣誉",
  "about.contact": "联系我们",
  "about.founded": "成立时间",
  "about.location": "所在地",
  "about.team": "核心团队",

  "contact.name": "姓名",
  "contact.email": "邮箱",
  "contact.phone": "电话",
  "contact.message": "留言",
  "contact.submit": "提交",
  "contact.success": "提交成功，我们会尽快与您联系！",
  "contact.error": "提交失败，请稍后再试。",

  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.article": "文章详情",
  "breadcrumb.about": "关于我们",

  "category.all": "全部",
  "category.loadmore": "加载更多",
  "category.noarticles": "暂无相关文章",

  "article.related": "相关文章",
  "article.back": "返回列表",

  "footer.company": "开元体育",
  "footer.description": "开元体育是专业的体育运动平台，致力于为运动爱好者提供高质量的体育赛事资讯、运动健身指导及体育娱乐服务。",
  "footer.quicklinks": "快速链接",
  "footer.categories": "运动分类",
  "footer.support": "支持服务",
  "footer.contactus": "联系我们",
  "footer.faq": "常见问题",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.copyright": "© 2024 开元体育 版权所有",
  "footer.newsletter": "订阅资讯",
  "footer.newsletterDesc": "获取最新体育资讯和优惠信息",
  "footer.subscribe": "订阅",

  "scrolltop": "返回顶部",
};

export default zh;